<template>
  <div>
    <a-tabs
      v-model="activeKey"
      class="custom-tab-container"
      @change="tabsChange"
    >
      <!-- 考试预约 Tab -->
      <a-tab-pane key="1" tab="考试预约">
        <!-- 给内容区加滚动容器类 -->
        <div class="hint" style="margin: 0">
          <a-icon type="exclamation-circle" class="icon" />
          您可以选择开通线上考试功能，开通后无需参加线下考试
          <a-button
            type="primary"
            :size="size"
            @click="goFee"
            style="margin-left: 20px"
          >
            点此开通
          </a-button>
        </div>
        <div class="hint">
          预约时间：{{ param.hy_appointment_time }}
        </div>
        <div class="hint">
          考试地点：郑州航空工业管理学院龙子湖校区（河南郑州郑东新区龙子湖文苑西路15号）。
        </div>
        <div class="hint">
          具体考试时间，考场在预约结束后由学校统一安排，请在
          <span style="color: red; margin: 0 10px">
            {{ param.hy_arrange_time }}
          </span>
          期间查看线下考试安排。<a-button
            type="primary"
            size="small"
            @click="activeKey = '2'"
            style="margin-left: 20px"
          >
            点此查看
          </a-button>
        </div>
        <div class="tab-content scrollable-container">
          <div style="margin-bottom: 50px">
            <div v-if="lastSemester.length > 0">
              <div class="hint">2027年上学期</div>
              <a-table
                :columns="courseColumns"
                :pagination="false"
                :data-source="lastSemester"
                bordered
                style="margin-bottom: 20px"
                size="small"
              >
                <template slot="index" slot-scope="text, record, index">
                  {{ index + 1 }}
                </template>
              </a-table>
            </div>
            <!-- <div v-if="nextSemester.length > 0">
              <div class="hint">{{userInfo.grade}}年下学期</div>
              <a-table
                :columns="courseColumns"
                :pagination="false"
                :data-source="nextSemester"
                bordered
                size="small"
              >
                <template slot="index" slot-scope="text, record, index">
                  {{ index + 1 }}
                </template>
              </a-table>
            </div> -->
          </div>
        </div>
        <div class="btn_out">
          <div class="hint" v-if="detail">
            您已经在<span style="margin: 0 10px;">{{ detail.createTime }}</span>预约成功！
            <a-button
              type="primary"
              :size="size"
              @click="cancel"
              style="margin-left: 20px"
            >
              点击取消预约
            </a-button>
          </div>
          <a-button type="primary" @click="reservation" v-else>
            点此预约
          </a-button>
        </div>
      </a-tab-pane>
      <!-- 预约记录 Tab -->
      <a-tab-pane key="2" tab="线下考试安排" force-render>
        <!-- 给表格外层加滚动容器类 -->
        <div class="scrollable-container">
          <div class="hint">
            <a-icon type="exclamation-circle" class="icon" />
            您可以选择开通线上考试功能，开通后无需参加线下考试
            <a-button
              type="primary"
              :size="size"
              @click="goFee"
              style="margin-left: 20px"
            >
              点此开通
            </a-button>
          </div>
          <div class="hint" v-if="detail">
            您已经在<span style="margin: 0 10px;">{{detail.createTime}}</span>预约成功！
            <a-button
              type="primary"
              :size="size"
              @click="cancel"
              style="margin-left: 20px"
            >
              点击取消预约
            </a-button>
          </div>
          <h1 style="margin-bottom: 20px; font-size: 16px">
            请您带上身份证及准考证，按时参加考试，没有参加考试将按照缺考处理。
          </h1>
          <a-table
            :columns="columns"
            :pagination="false"
            :data-source="tableData"
            :locale="{ emptyText: '暂无考试安排' }"
            bordered
            size="small"
          >
          </a-table>
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      activeKey: "1",
      size: "small",
      param: JSON.parse(localStorage.getItem("homeObj")),
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      courseColumns: [
        {
          title: "序号",
          align: "center",
          scopedSlots: { customRender: "index" },
          width: 300,
          customHeaderCell: (column) => {
            // 可以根据column信息进行条件判断
            return {
              style: {
                fontWeight: "bold",
                fontSize: "16px",
                // 任何有效的CSS样式
              },
            };
          },
          customCell: () => {
            return {
              style: { color: "#000" },
            };
          },
        },
        {
          title: "课程名称",
          dataIndex: "viewName",
          key: "viewName",
          align: "left",
          customHeaderCell: (column) => {
            // 可以根据column信息进行条件判断
            return {
              style: {
                fontWeight: "bold",
                fontSize: "16px",
                // 任何有效的CSS样式
              },
            };
          },
          customCell: () => {
            return {
              style: { color: "#000" },
            };
          },
        },
      ],
      columns: [
        {
          title: "课程",
          dataIndex: "name",
          key: "name",
          align: "center",
          customHeaderCell: (column) => {
            // 可以根据column信息进行条件判断
            return {
              style: {
                fontWeight: "bold",
                fontSize: "16px",
                // 任何有效的CSS样式
              },
            };
          },
          customCell: () => {
            return {
              style: { color: "#000" },
            };
          },
        },
        {
          title: "考试时间",
          dataIndex: "time",
          key: "time",
          align: "center",
          customHeaderCell: (column) => {
            // 可以根据column信息进行条件判断
            return {
              style: {
                fontWeight: "bold",
                fontSize: "16px",
                // 任何有效的CSS样式
              },
            };
          },
          customCell: () => {
            return {
              style: { color: "#000" },
            };
          },
        },
        {
          title: "考试地点",
          dataIndex: "location",
          key: "location",
          align: "center",
          customHeaderCell: (column) => {
            // 可以根据column信息进行条件判断
            return {
              style: {
                fontWeight: "bold",
                fontSize: "16px",
                // 任何有效的CSS样式
              },
            };
          },
          customCell: () => {
            return {
              style: { color: "#000" },
            };
          },
        },
        {
          title: "考场",
          dataIndex: "site",
          key: "site",
          align: "center",
          customHeaderCell: (column) => {
            // 可以根据column信息进行条件判断
            return {
              style: {
                fontWeight: "bold",
                fontSize: "16px",
                // 任何有效的CSS样式
              },
            };
          },
          customCell: () => {
            return {
              style: { color: "#000" },
            };
          },
        },
      ],
      lastSemester: [],
      nextSemester: [],
      tableData: [],
      detail: null,
      // tableData: [
      //   {
      //     name: "古代汉语",
      //     time: "2025年12月29日 09:30 - 11:30",
      //     location:
      //       "郑州航空工业管理学院龙子湖校区（河南郑州郑东新区龙子湖文苑西路15号）",
      //     site: "3号教学楼1楼101教室座号7",
      //   },
      //   {
      //     name: "形势与政策(2)",
      //     time: "2025年12月29日 15:00 - 17:00",
      //     location:
      //       "郑州航空工业管理学院龙子湖校区（河南郑州郑东新区龙子湖文苑西路15号）",
      //     site: "3号教学楼1楼101教室座号7",
      //   },
      // ],
    };
  },

  methods: {
    async getPlanList() {
      let res = await this.axios.get(`/biz/subject/plan/list?layoutYear=${2027}`);
      const { result } = res;
      result.map((res) => {
        if (res.planTermName == "下学期") {
          // this.nextSemester.push(res);
        } else {
          this.lastSemester.push(res);
        }
      });
    },
    tabsChange(e) {},
    async reservation() {
      let taht = this;
      let semesterList = [];
      if (this.lastSemester.length > 0) {
        semesterList.push("上学期");
      }
      if (this.nextSemester.length > 0) {
        semesterList.push("下学期");
      }
      let data = {
        eduCode: this.userInfo.eduCode,
        studentId: this.userInfo.id,
        termYear: this.userInfo.grade,
        termName: semesterList.toString(),
      };
      this.$confirm({
        content: "您确定预约线下考试吗，预约成功后需到校考试！",
        async onOk() {
          try {
            let res = await taht.axios.post("/biz/exam/reserve/submit", data);
            if (res.code == 200) {
              taht.$message.success("预约成功");
              taht.getDetail()
            }
            // 使用结果
          } catch (err) {
            // 处理错误
            taht.$destroyAll();
          }
        },
        cancelText: "取消",
        onCancel() {
          taht.$destroyAll();
        },
      });
    },
    async getDetail() {
      let res = await this.axios.get("/biz/exam/reserve/detail");
      this.detail = res.result;
    },
    cancel() {
      let taht = this;
      this.$confirm({
        content: "您确定取消预约线下考试吗!",
        async onOk() {
          try {
            let res = await taht.axios.get("/biz/exam/reserve/cancel");
            if (res.code == 200) {
              taht.$message.success("取消成功");
              taht.getDetail()
            }
            // 使用结果
          } catch (err) {
            // 处理错误
            taht.$destroyAll();
          }
        },
        cancelText: "取消",
        onCancel() {
          taht.$destroyAll();
        },
      });
    },
    goFee() {
      this.$router.push("/personalcenters/payment");
    },
  },

  created() {
    this.getPlanList();
    this.getDetail();
  },
};
</script>

<style scoped lang="stylus">
@import '~styles/varibles.styl'

.btn_color{
  background-color: $bgColor;
  color: #fff;
  border:$bgColor;
}
.applyExamTitle{
  height: 40px;
  background-color: #FEFAED;
  padding: 0px 0px 0px 10px;

}
.tab-content{
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-size: 14px;
  color: #333333;
  line-height: 36px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.modal-container {
  display: flex;
  flex-direction: column; /* 子元素垂直排列 */
  align-items: center;    /* 水平居中 */
        /* 上下内边距，增加间距 */
}

/* 确认文本：居中显示，去除默认列表样式 */
.confirm-text {
  list-style: none;       /* 去掉默认列表符号 */
  padding: 0;
  margin: 20px 0 20px 0;     /* 底部间距 */
  text-align: center;     /* 文本居中 */
  font-size: 16px;
  color: #333;
}

/* 按钮组：水平排列 + 居中，按钮间距 */
.button-group {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;          /* 按钮水平排列 */
  gap: 60px;
  margin: 10px 0 10px 0;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #FFFFFF;
  text-align: center;
  font-style: normal;
  text-transform: none;
}
.applySuccessText{
  font-family: MicrosoftYaHei;
  font-size: 18px;
  color: #333333;
  text-align: center;
  font-style: normal;
  text-transform: none;
  margin-top: 20px;
}
._bgcolor{
  color: $bgColor;
}

.custom-tab-container {
  /* 1. 未选中标签的字体颜色 */
  /deep/ .ant-tabs-tab {
    color: #666 !important; /* 灰色，!important 确保覆盖默认样式 */
  }
  /* 2. 选中标签的字体颜色 */
  /deep/ .ant-tabs-tab.ant-tabs-tab-active {
    color: $bgColor !important; /* 蓝色（与方案1一致） */
  }
  /* 3. 鼠标 hover 标签的字体颜色 */
  /deep/ .ant-tabs-tab:hover {
    color: $bgColor !important; /* hover 时也显示蓝色，可选调整 */
  }
  /deep/ .ant-tabs-ink-bar {
    background-color: $bgColor !important; /* 线条也改为红色，保持统一 */
  }
}
/* 滚动容器：固定高度 + 纵向滚动 */
.scrollable-container {
  /* 1. 设置固定高度（根据页面布局调整，如400px；或用calc适配屏幕） */
  max-height: 600px; /* 推荐用max-height：内容少则自适应，多则滚动 */
  /* 或用calc计算高度（例如：屏幕高度 - 顶部导航高度 - 其他间距） */
  /* max-height: calc(100vh - 220px); */

  /* 2. 纵向滚动：内容超出时显示滚动条，否则隐藏 */
  overflow-y: auto;

  /* 3. 可选：美化滚动条（适配Chrome/Safari，其他浏览器默认） */
  &::-webkit-scrollbar {
    width: 6px; /* 滚动条宽度 */
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #e5e7eb; /* 滚动条滑块颜色 */
    border-radius: 3px; /* 滑块圆角 */
  }
  &::-webkit-scrollbar-track {
    background-color: #f9fafb; /* 滚动条轨道颜色 */
  }

  /* 4. 可选：添加内边距，避免内容贴边 */
  padding: 0 8px;
}

/* 可选：调整考试列表样式，避免内容拥挤 */
.tab-content ul {
  list-style: none; /* 清除默认列表符号 */
  padding: 0;
  margin: 8px 0;
}
.btn_out{
  background-color: #fff;
  padding:20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.hint{
  font-size:16px;
  color:#000;
  display: flex;
  align-items: center;
  margin: 10px 0
}
.icon{
  color:red;
  margin-right: 5px
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/ApplyOfflineExamV2.vue